import React from "react";
import SEO from "../components/SEO";
import HeroSection from "../components/violetblock/heroSection";
import Facilities from "../components/violetblock/facilities";
import Activities from "../components/violetblock/activities";
import Appointment from "../components/violetblock/appointment";
import About from "../components/violetblock/About";
import PTA from "../components/violetblock/PTA";

const VioletBlock = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <SEO
        title="About Us & Violet Block"
        description="Learn about the Violet Block at St. Thomas Vidyalayam, including school facilities, activities, the PTA, and our mission."
        keywords="Violet Block, STVMHSS About, School Facilities, PTA, School Mission"
        canonicalPath="/violetblock"
      />

      <h1 className="sr-only">Violet Block — STVMHS</h1>

      {/* Hero Section */}
      <HeroSection />

      {/* Main Content Container */}
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Facilities Section */}
        <section
          className="py-12 sm:py-16 lg:py-20"
          aria-labelledby="violet-facilities-heading"
        >
          <h2 id="violet-facilities-heading" className="sr-only">
            Facilities
          </h2>
          <Facilities />
        </section>

        {/* About Section */}
        <section
          className="py-12 sm:py-16 lg:py-20"
          aria-labelledby="violet-about-heading"
        >
          <h2 id="violet-about-heading" className="sr-only">
            About
          </h2>
          <About />
        </section>

        {/* Activities Section */}
        <section
          className="py-12 sm:py-16 lg:py-20"
          aria-labelledby="violet-activities-heading"
        >
          <h2 id="violet-activities-heading" className="sr-only">
            Activities
          </h2>
          <Activities />
        </section>

        {/* PTA Section */}
        <section
          className="py-12 sm:py-16 lg:py-20"
          aria-labelledby="violet-pta-heading"
        >
          <h2 id="violet-pta-heading" className="sr-only">
            Parent Teacher Association
          </h2>
          <PTA />
        </section>

        {/* Appointment Section */}
        <section
          className="py-12 sm:py-16 lg:py-20"
          aria-labelledby="violet-appointment-heading"
        >
          <h2 id="violet-appointment-heading" className="sr-only">
            Appointment
          </h2>
          <Appointment />
        </section>
      </div>
    </div>
  );
};

export default VioletBlock;
